import React,{useEffect} from 'react';
import { Helmet } from 'react-helmet';
import Button from '../../../../components/button/button';
import { useNavigate } from 'react-router-dom';

const Landing = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    window.fbq("trackCustom", "ResellSuccess");
  }, []);
  const navigate = useNavigate();

  const handleViewClick = () => {
    navigate('/my-listing'); // Navigate to the listings page
  };
  return (
    <div className="flex flex-col m-5 p-10 bg-grey-5 rounded-xl justify-center items-center">
      <Helmet>
        <title>Sell tickets</title>
        <meta
          name="Sell Tickets Easily in India | Reach Your Audience on Take My Tickets"
          content="Start selling your event tickets hassle-free on Take My Tickets, India's trusted ticket resale platform. Add seller contact details effortlessly."
        />
        <meta charset="UTF-8" />
      </Helmet>
      <img
        src="assets/images/alldone.gif"
        alt="alldone"
        loop="false"
        className="pb-10"
        loading="lazy"
      />
      <div className="md:heading-36 heading-24">
        Ta da! Your listing is created!
      </div>
      <div className="text-14 pt-2 pb-6">
        We'll keep you in the loop as soon as we find the perfect buyer for your
        tickets. Stay tuned!
      </div>
      <Button type="primary-black"
        onClick={handleViewClick}>
        View My Listings
      </Button>
    </div>
  );
}

export default Landing
